module.exports = __webpack_public_path__ + "img/fig25.54e0abc1.jpg";